import { Typography, Box, Grid, Divider, List, ListItem } from "@mui/material"

const Preview = ({fieldValues, selectedColor, fullHeight=false, page='preview', sections}) =>{
  let headerFontSize ='30px',subHeaderFontSize ='16px', headerPadding = 5, contentpadding = 3,subContentPadding = 1, titleFontSize = '20px', subTitleFontSize='18px', contentFontSize = '16px', ratingSize = '1.5rem';
  if(page === 'template'){
      headerFontSize = '16px'
      subHeaderFontSize = '10px'
      headerPadding = 2
      contentpadding = 1
      subContentPadding = 0.5
      titleFontSize = '12px'
      subTitleFontSize = '10px'
      contentFontSize = '10px'
      ratingSize = '1rem'
  }

  const getskillsContent = () =>{
    return <><Box sx={{ backgroundColor: selectedColor?.[1] || '#a98462', padding: subContentPadding }}>
    <Typography variant="body" sx={{ fontWeight: 600,pl:1, fontSize:titleFontSize, color: selectedColor?.[2] || '#000' }}>
      Skills
    </Typography>
  </Box>
  <List disablePadding sx={{ px: contentpadding, py:subContentPadding }}>
          {fieldValues.skills.map((skill, index) => {
              return <ListItem key={index} disablePadding sx={{ py: 0.5, fontSize: contentFontSize,color: selectedColor?.[2] || '#000'}}>{skill.skill}</ListItem>
          })}
  </List></>
  }
  const getexperienceContent = () =>{
    return <Box sx={{ p: contentpadding, color: "#000" }}>
    <Typography sx={{ fontWeight: 600, fontSize: titleFontSize }}>
      Work History
    </Typography>
    <Divider sx={{borderColor: selectedColor?.[1] || "#a98462" }} />
    {fieldValues.experience.map((exp, index) => {
      return (
        <Box py={contentpadding} key={index}>
          <Box sx={{display: "flex", alignItems: "center",justifyContent: "space-between"}}>
            <Box>
              <Typography sx={{fontSize: subTitleFontSize, color: '#000', fontWeight: 600,wordBreak: "break-word"}}>
                {exp.job_title}
              </Typography>
              <Typography component="p" sx={{fontStyle: "italic",color:  '#000',fontSize: contentFontSize,wordBreak: "break-word"}}>
                {exp.employer}
              </Typography>
            </Box>
            <Box flexShrink={0}>
              <Typography sx={{fontSize: contentFontSize,color: '#000',fontStyle: "italic"}}>
                {exp.start_date[1]} {exp.start_date[0]} -{" "}
                {exp.end_date[1]} {exp.end_date[0]}
              </Typography>
            </Box>
          </Box>
          <Box p={subContentPadding}>
            {exp.description ? (
              <Typography sx={{ fontSize: contentFontSize, color: '#000'}} dangerouslySetInnerHTML={{__html: exp.description.toString("html")}}></Typography>
            ) : (
              ""
            )}
          </Box>
        </Box>
      );
    })}
  </Box>
  }
  const geteducationContent = () =>{
    return <Box sx={{ p: contentpadding }}>
    <Typography sx={{ fontWeight: 600, color: "#000", fontSize: titleFontSize }}>
      Education
    </Typography>
    <Divider sx={{borderColor:selectedColor?.[1]|| "#a98462", marginBottom: "10px" }} />
    {fieldValues.education.map((edu, index) => {
          return <Box key={index}>
              <Typography sx={{fontSize:subTitleFontSize}}>{edu.degree} in {edu.field_of_study} of  {edu.start_date[0]} - {edu.end_date[0]}</Typography>
              <Typography sx={{fontSize: contentFontSize}}>{edu.school_name}, {edu.school_location}</Typography>
          </Box>
      })}
  </Box>
  }
  const getotherContent = () =>{
    return fieldValues.other.map((other, index)=>{
      return <Box key={index} sx={{color:'#383838'}}>
          {other.title ? <Box sx={{ backgroundColor: selectedColor?.[1] || '#a98462', padding: subContentPadding }}>
            <Typography variant="body" sx={{ fontWeight: 600,pl:1, fontSize:titleFontSize, color: selectedColor?.[2] || '#000' }}>
              {other.title}
            </Typography>
          </Box> : ""}
          {other.content ? <Box sx={{ px: contentpadding, py:subContentPadding }}><Typography sx={{fontSize:contentFontSize, color: selectedColor?.[2] || '#000'}} dangerouslySetInnerHTML={{__html: other.content?._cache?.html ? other.content?._cache?.html.toString('html') : other.content.toString('html')}}></Typography></Box> : ''}
      </Box>
  })
  }

    return  <Box sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", flexGrow: 1, display:"flex", width:"100%",  height: fullHeight ? "100%" : 'auto'  }} >
        <Grid container>
          <Grid item xs={4} sx={{ backgroundColor: selectedColor?.[0] || "#bc936d"}}>
            <Box sx={{ padding: '16px', paddingTop: '30px'}}>
              <Typography sx={{ fontWeight: 600, fontSize:headerFontSize, color: selectedColor?.[2] || '#000' }}>{fieldValues.f_name || "John"} {fieldValues.l_name}</Typography>
              <Typography sx={{color: selectedColor?.[2] || '#000', fontSize:subHeaderFontSize }}>{fieldValues.city || 'Chennai'}, {fieldValues.state || 'Tamilnadu'}</Typography>
              <Typography sx={{color: selectedColor?.[2] || '#000', fontSize:subHeaderFontSize }}>{fieldValues.phone || '9876543210'}</Typography>
              <Typography sx={{color: selectedColor?.[2] || '#000', fontSize:subHeaderFontSize }}>{fieldValues.email || 'xxx@gmail.com'}</Typography>
            </Box>
            {sections?.map((section)=>{
                    if(section === 'Skills'){
                        return fieldValues.skills.length ? getskillsContent() : ''
                    }else if(section === 'Other'){
                        return fieldValues.other.length && fieldValues.other[0].title ? getotherContent() : ''
                    }
                    return ''
                })
            }
          </Grid>
          <Grid item xs={8}>
            {fieldValues.objective ? <Box sx={{ p:contentpadding, paddingTop: '30px', color: "#000"}}>
              <Typography sx={{ fontSize: contentFontSize, fontWeight: 600 }}>{fieldValues.objective}</Typography>
            </Box> : ""}
            {sections?.map((section)=>{
                    if(section === 'Education'){
                        return fieldValues.education.length ? geteducationContent() : ''
                    }else if(section === 'Experience'){
                        return fieldValues.experience.length ? getexperienceContent() : ''
                    }
                    return ''
                })
            }    
          </Grid>
        </Grid>
  </Box>
}

export default Preview